import React from "react";

const Explore = () => {
  return <div className="primary">Explore</div>;
};

export default Explore;
